import { type FC, Suspense } from 'react';
import { Outlet } from 'react-router';

import type { TLoadingActionType } from '@/store/loading.slice';

import SuspenseFallback from './suspense-fallback';

type TProps = {
  loadingType?: TLoadingActionType;
};

const SuspenseRoute: FC<TProps> = ({ loadingType }) => {
  return (
    <Suspense fallback={<SuspenseFallback loadingType={loadingType} />}>
      <Outlet />
    </Suspense>
  );
};

export default SuspenseRoute;
